import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { rolePermissionsService } from '@/api/domains/authorization/rolePermissions.service';
import { useExport } from '@/hooks/ui/useExport';


interface UsePermissionsExportResult {
  onExport: () => Promise<void>;
  isExporting: boolean;
}

export function usePermissionsExport(selectedRoleId: number | null): UsePermissionsExportResult {
  const { t: translate } = useTranslation();

  const { onExport: exportFile, isExporting } = useExport({
    exportFn: () => rolePermissionsService.exportPermissionsFile(selectedRoleId as number),
    successMessage: translate('authorization:permissions.messages.exportSuccess'),
    errorMessage: translate('authorization:permissions.messages.exportError'),
  });

  const onExport = useCallback(async () => {
    if (!selectedRoleId) return;
    await exportFile();
  }, [selectedRoleId, exportFile]);

  return { onExport, isExporting };
}

export default usePermissionsExport;
